import React from "react";
import dropdownIcon from "../../../assets/componentsIcons/dropdown/dropdown.svg";
import editIcon from "../../../assets/componentsIcons/dropdown/edit.svg";
import UtilHelper from "../../../utils/UtilHelper";
import ActionMenu from "../../../newComponents/actionMenus/action-menu";
import { GetImages } from "../../../utils/GetImages";
import { usePermissions } from "../../../hooks/usePermissions";

interface Props {
  listingData: any;
  onEdit: () => void;
}

const FeedbackCardItem: React.FC<Props> = ({ listingData, onEdit }) => {
  const check = usePermissions();
  const canWrite = check.canWrite("Feedback");

  const menuItems = [
    { icon: editIcon, label: "Edit", action: onEdit },
  ];

  return (
    <div className="listing-card organisation-listing-card">
      <div className="listing-card-header">
        <div className="tenant-avatar">
          <div className="tenant-initials">
            {UtilHelper.getInitials(listingData?.formatted?.FeedbackTypeId || "FB")}
          </div>
        </div>

        <div className="listing-details">
          <div className="listing-info-container">
            <div className="listing-info">
              <h3 className="listing-address">{listingData?.formatted?.FeedbackTypeId || "Feedback"}</h3>
              <p className="listing-type feedback-card-description mt-2">{listingData.feedbackDescription}</p>
              <div className="feedback-card-date d-flex align-items-center">
                <img src={GetImages.calendarIcon} alt="info" width={20} height={20} className="stat-icon me-1" />
                {listingData?.formatted?.CreatedDateString}
              </div>
            </div>
          </div>
        </div>

        <div className="listing-progress-wrapper">
          <span className={`listing-status-badge ${listingData?.formatted?.FeedbackStatus?.toLowerCase()}`}>
            {listingData?.formatted?.FeedbackStatus}
          </span>
        </div>

        {canWrite && (
        <ActionMenu
          trigger={<img src={dropdownIcon} alt="Menu" width={26} height={26} className="iconStyleWithWhiteFilter"/>}
          menuItems={menuItems}
          Id={listingData.id}
        />
        )}
      </div>
    </div>
  );
};

export default FeedbackCardItem;